module.exports = __webpack_public_path__ + "img/global-loading.65a3c3ea.gif";